module.exports = __webpack_public_path__ + "front/img/sub-img-3-wap.5b0df205.png";